// TODO: Import React module
import { useCallback, useEffect, useState } from 'react';

// TODO: Import MUI module
import { Box, Button, Grid, Stack, Typography } from '@mui/material';

// TODO: Import MUI icon
import { } from '@mui/icons-material';

// TODO: Import context
import { fetchData, } from '../../Common/Context';

// TODO: Import custom component
import BoxSubPage from '../../Common/BoxSubPage';

// TODO: Export component
const imageBaseUrl = 'https://www.pohtyh.edu.hk/Files/CafeOrder';

const CafeOrderStaff = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component CafeOrderStaff Rendered');

    // TODO: Define useContext

    // TODO: Define variable
    const [rows, setRows] = useState([]);

    // TODO: Define event
    useEffect(() => { window.scrollTo(0, 0); }, []);

    const getOrder = useCallback(() => {
        const formData = new FormData();
        formData.append('action', 'CafeOrderStaff_GetOrder');
        fetchData(formData, (result) => { setRows(result) });
    }, []);

    const updateStatus = (item, status) => {
        const formData = new FormData();
        formData.append('action', 'CafeOrderStaff_ToggleOrderStatus');
        formData.append('orderNo', item.OrderNo);
        formData.append('status', status.toString());
        console.log('testA', status);
        if (status === 1) {
            console.log(item);
            formData.append('email', item.Email);
            formData.append('cName', item.CName);
            formData.append('eName', item.EName);
        }
        fetchData(formData, (result) => {
            getOrder();
            console.log(result);
        });
    };


    useEffect(() => {
        getOrder();

        const id = setInterval(() => {
            getOrder();
        }, 10000);

        return () => clearInterval(id);
    }, [getOrder]);

    // TODO: Return component
    return (
        <BoxSubPage
            id="CafeOrderStaff"
            disableTop={true}
            disableMenu={true}
            disableSubtitle={true}
            disableDivider={true}
            disableFooter={true}
        >
            <Stack spacing={2} sx={{ mb: 4 }}>
                <Grid container spacing={4}>
                    {rows.map(item => (
                        <Grid key={item.OrderNo} size={{ xs: 6, sm: 4, md: 3, }}>
                            <Stack sx={{ alignItems: 'center' }}>
                                <Box
                                    component={'img'}
                                    src={`${imageBaseUrl}/${item.ID}.webp`}
                                    sx={{ width: 1, maxWidth: 300 }}
                                />
                                <Typography sx={{ fontWeight: 'bold' }} variant="h6">
                                    {`訂單編號: ${item.OrderNo}`}
                                </Typography>
                                <Stack direction="row" spacing={1}>
                                    <Typography variant="h6">{item.CName}</Typography>
                                    <Typography variant="h6">{item.EName}</Typography>
                                </Stack>
                                {item.ContactNo &&
                                    <Typography variant="h6">{`聯絡號碼: ${item.ContactNo}`}</Typography>}
                                <Button
                                    color={parseInt(item.Status) === 1 ? `primary` : `error`}
                                    onClick={() => { updateStatus(item, parseInt(item.Status) === 1 ? 0 : 1) }}
                                    size="large"
                                    variant="contained"
                                >
                                    {parseInt(item.Status) === 1 ? `已完成 Completed` : `未完成 Incomplete`}
                                </Button>
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
            </Stack>
        </BoxSubPage>
    );
};

export default CafeOrderStaff;